import { useTheme } from '../theme/theme-context.js';

const HeaderLogoMobile = ({ LogoFull, LogoFavicon, availableWidthForLogo }) => {
	const { LOGO_MOBILE_WIDTH } = useTheme(); // width of svg logo
	return (
		<>
			{!LOGO_MOBILE_WIDTH && <div />}
			{LOGO_MOBILE_WIDTH && (
				<div>{availableWidthForLogo > LOGO_MOBILE_WIDTH ? <LogoFull /> : <LogoFavicon />}</div>
			)}
		</>
	);
};

export default HeaderLogoMobile;
